import { EntityState } from "../types";

export const STATE_TYPE = {
	TV: "TV",
	WEATHER: "WEATHER",
	FIREPLACE: "FIREPLACE",
	CABIN_CAT: "CABIN_CAT",
} as const;

export const STATES = {
	TV: {
		ON: "tv-on",
		OFF: "tv-off",
	},
	CABIN_CAT: {
		SLEEP: "cat-sleep",
		TWITCH: "cat-twitch",
		YAWN: "cat-yawn",
	},
	FIREPLACE: {
		ON: "fire-on",
		OFF: "fire-off",
	} as const,
	WEATHER: {
		DRIZZLE: "drizzle",
	} as const,
} as const;

export const ENTITIES = {
	TV: {
		CABIN: "cabin-tv",
	},
	CABIN_CAT: {
		CABIN: "cabin-cat",
	},
	FIREPLACE: {
		CABIN: "cabin-fireplace",
	},
	WEATHER: {
		CABIN: "cabin-weather",
	},
} as const;

export const DEFAULT_ENTITIES = {
	TV: [
		{
			id: ENTITIES.TV.CABIN,
			default: STATES.TV.OFF,
		} as const,
	],
	CAT: [
		{
			id: ENTITIES.CABIN_CAT.CABIN,
			default: STATES.CABIN_CAT.SLEEP,
		} as const,
	],
	FIREPLACE: [
		{
			id: ENTITIES.FIREPLACE.CABIN,
			default: STATES.FIREPLACE.ON,
		} as const,
	],
	WEATHER: [
		{
			id: ENTITIES.WEATHER.CABIN,
			default: STATES.WEATHER.DRIZZLE,
		} as const,
	],
};
export type EntityType = keyof typeof STATE_TYPE;
export type EntityConfig = Record<
	string,
	{
		id: (typeof ENTITIES)[keyof typeof ENTITIES][keyof (typeof ENTITIES)[keyof typeof ENTITIES]];
		default: string;
		type: EntityType;
	}
>;

// STATE
export type FireplaceState = (typeof STATES.FIREPLACE)[keyof typeof STATES.FIREPLACE];
export type WeatherState = (typeof STATES.WEATHER)[keyof typeof STATES.WEATHER];
export type TvState = (typeof STATES.TV)[keyof typeof STATES.TV];

// IDS
export type FireplaceId = (typeof ENTITIES.FIREPLACE)[keyof typeof ENTITIES.FIREPLACE];
export type WeatherId = (typeof ENTITIES.WEATHER)[keyof typeof ENTITIES.WEATHER];
export type TvId = (typeof ENTITIES.TV)[keyof typeof ENTITIES.TV];

export const DEFAULT_GLOBAL_STATE = Object.fromEntries([
	...DEFAULT_ENTITIES.TV.map((e) => [
		e.id,
		{
			id: e.id,
			type: STATE_TYPE.TV,
			value: e.default,
		},
	]),
	...DEFAULT_ENTITIES.CAT.map((e) => [
		e.id,
		{ id: e.id, type: STATE_TYPE.CABIN_CAT, value: e.default },
	]),
	...DEFAULT_ENTITIES.FIREPLACE.map((e) => [
		e.id,
		{ id: e.id, type: STATE_TYPE.FIREPLACE, value: e.default },
	]),
	...DEFAULT_ENTITIES.WEATHER.map((e) => [
		e.id,
		{ id: e.id, type: STATE_TYPE.WEATHER, value: e.default },
	]),
]) as Record<string, EntityState>;
